(function () {
  function init() {
    var wrapper = document.querySelector('[data-back-button-wrapper]');
    var button = document.querySelector('[data-back-button]');
    var label = document.querySelector('[data-back-button-label]');
    if (!wrapper || !button) return;

    var referrer = document.referrer;
    if (!referrer) return;

    var referrerUrl;
    try {
      referrerUrl = new URL(referrer);
    } catch (error) {
      return;
    }

    if (referrerUrl.origin !== window.location.origin) {
      return;
    }

    button.href = referrerUrl.href;

    if (label) {
      label.textContent = referrerUrl.pathname.startsWith('/search')
        ? window.backButtonStrings.backToSearch
        : window.backButtonStrings.backToCollection;
    }

    button.addEventListener('click', function (event) {
      event.preventDefault();
      try {
        sessionStorage.setItem('scrollPositionRestore:' + referrerUrl.pathname + referrerUrl.search, '1');
      } catch (error) {
        // sessionStorage unavailable
      }

      if (window.history.length > 1) {
        window.history.back();
        return;
      }

      window.location.href = referrerUrl.href;
    });

    wrapper.hidden = false;
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
